<template>
  <div class="quick-cs-btn">
    <div class="handler-btn"  @click="showExclusiveCustomerService">
      联系签证专家
    </div>

    <exclusive-cs-dialog
      :visible.sync="isShowExclusiveCustomerService"
      :peer-c-s-data="peerCSData"
    ></exclusive-cs-dialog>
  </div>
</template>

<script>
import ExclusiveCsDialog from '@/components/custom-service/components/exclusive-cs-dialog.vue';
import { mapState, mapActions, mapMutations } from 'vuex';
import User from '@/libs/user';
import sensorsdata from 'sa-sdk-javascript';

export default {
  components: {
    ExclusiveCsDialog,
  },
  data() {
    return {
      isShowExclusiveCustomerService: false,
    };
  },
  computed: {
    ...mapState('user', ['peerCSData']),
    ...mapState('chatVisa', ['chatVisaFrameBurialPoint',
    ]), 
  },
  created() {
    if (User.isLogin()) {
      this.getPeerCSData();
    }
  },
  methods: {
    ...mapMutations(['SHOW_LOGIN_BOX']),
    ...mapActions('user', ['getPeerCSData']),
    showExclusiveCustomerService() {
      sensorsdata.track('qw_ve_click', {});
      if (User.isLogin()) {
        this.isShowExclusiveCustomerService = true;
      } else {
        this.SHOW_LOGIN_BOX();
      }
    },
  },
};
</script>

<style lang="less" scoped>
.quick-cs-btn {
  display: flex;
  align-items: center;
}

.contact-ve {
  width: 88px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  background: #ffffff;
  border-radius: 2px;
  border: 1px solid #e9eef2;
  backdrop-filter: blur(10px);
  font-size: 12px;
  color: #2f333d;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/chat-visa/components/quick-cs-btn.vue